import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ContactUs from './components/contact/ContactUs';
import AboutUs from './components/contact/AboutUs';
import WorkforceManagement from './pages/verticals/WorkforceManagement';
import GlobalTechnology from './pages/verticals/GlobalTechnology';

import ItItes from './pages/verticals/ItItes';
import Healthcare from './pages/industries/Healthcare';
import EducationTechnology from './pages/industries/EducationTechnology';
import SoftwareDevelopment from './pages/industries/SoftwareDevelopment';
import Careers from './components/contact/careers';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './App.css';
import Digitalmarketing from './pages/verticals/Digitalmarketing';
import Telecommunication from './pages/industries/Telecommunication';
import BusinessProcessOutsourcing from './pages/industries/BusinessProcessOutsourcing';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactUs/>} />
            <Route path="/aboutus" element={<AboutUs />} />
             <Route path="/careers" element={<Careers/>} />
            {/* Business Verticals */}
            <Route path="/verticals/workforce-management" element={<WorkforceManagement />} />
            <Route path="/verticals/global-technology" element={<GlobalTechnology />} />
            <Route path="/verticals/it-ites" element={<ItItes />} />
            <Route path="/verticals/digital-marketing" element={<Digitalmarketing />} />
          
            {/* Industries */}
            <Route path="/industries/healthcare" element={<Healthcare />} />
            <Route path="/industries/education-technology" element={<EducationTechnology />} />
            <Route path="/industries/telecommunication" element={<Telecommunication />} />
           <Route path="/industries/business-process-outsourcing" element={<BusinessProcessOutsourcing />} />
            <Route path="/industries/software-development" element={<SoftwareDevelopment />} />
            {/* Other Pages */}
           
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
